/* import { Md5 } from 'ts-md5/dist/md5';
import { API_URL2, IVA, respuesta, terminal } from './../../../app.constants';
import { PalcosDataService } from 'src/app/service/data/palcos-data.service';
import { ActivatedRoute } from '@angular/router';
import { HardcodedAutheticationService } from './../../../service/hardcoded-authetication.service';
import { UsuariosDataService } from './../../../service/data/usuarios-data.service';
import { Palco } from './../../../administradores/admin-perfil/admin-eventos/admin-palcos/palco.model';
import { Cliente } from './../../cliente.model';
import { Component, OnInit } from '@angular/core';
import { MensajeComponent } from 'src/app/mensaje/mensaje.component';
import { MatDialog } from '@angular/material/dialog';
import { OrdenDataService } from 'src/app/service/data/orden-data.service';


@Component({
  selector: 'app-agregar-amigos',
  templateUrl: './agregar-amigos.component.html',
  styleUrls: ['./agregar-amigos.component.css']
})
export class AgregarAmigosComponent implements OnInit {
  clienteNoEsNulo: boolean = false;
  user = '';
  usuario: Cliente
  palco: Palco
  idPalco
  clientes: Cliente[] = []
  clienteAgregado: Cliente
  numeroDocumento
  IVA
  merchantId
  accountId
  ApiKey
  referenceCode: string
  porcentaje
  borrar: boolean
  taxAdicion = 0
  tax = 0
  idEvento: string
  valorAPagar = 0
  valorPagarAdicion = 0
  seleccionAdicion
  listaAdiciones: number[]
  entrarPersonas: number
  terminal
  respuesta
  codigoOrden
  descripcion
  cargando
  url
  constructor(private route: ActivatedRoute,
    private ordenService: OrdenDataService,
    private autenticador: HardcodedAutheticationService, private dataServicio: UsuariosDataService, private palcoServicio: PalcosDataService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.url = 'https://merchant.paymentsway.co/cartaspago/redirect'
    this.cargando = true
    this.terminal = terminal
    this.respuesta = respuesta
    this.entrarPersonas = 0
    this.listaAdiciones = []
    this.IVA = IVA
    this.borrar = false


    this.clienteAgregado = {
      celular: null,
      contrasena: null,
      correo: null,
      nombre: null,
      numeroDocumento: null,
      publicidad: null,
      tipoDocumento: null,
      usuario: null,
      tipo: null
    }

    this.usuario = {
      nombre: "",
      numeroDocumento: null,
      tipoDocumento: "",
      usuario: "",
      contrasena: "",
      celular: null,
      correo: "",
      publicidad: null,
      tipo: null
    }
    this.palco = {
      id: null,
      nombre: null,
      nombreEvento: null,
      personasAdentro: null,
      personasMaximas: null,
      precio: null,
      precioParcialPagado: null,
      reservado: null,
      servicio: null,
      vendido: null,
      numeroDentroDeEvento: null,
      fechaVendido: null,
      servicioIva: null,
      proceso: null,
      disponible: null,
      idLocalidad: null,
      reserva: null,
      precioAlterno: null,
      servicioAlterno: null,
      servicioIvaAlterno: null,
      adiciones: null,
      maximoAdiciones: null,
      precioAdicion: null,
      servicioAdicion: null,
      servicioIvaAdicion: null,
      metodo: null

    }

    this.user = this.autenticador.getUsuario();

    this.route.paramMap.subscribe(params => {
      this.idPalco = params.get('idPalco');
      this.dataServicio.getCliente(this.user).subscribe(response => {
        this.usuario = response;


        this.refrescarPalco()
      })
    })

  }



  refrescarPalco() {
    if (this.usuario != null) {
      this.palcoServicio.getPalcoAmigos(0, this.idPalco).subscribe(response => {
  
        this.palco = response.palco;
        this.idEvento = response.evento;
   
        let cantidad = this.palco.maximoAdiciones - this.palco.personasMaximas;
        for (let i = 1; i <= cantidad; i++) {
          this.listaAdiciones.push(i);
        }
  
        
        if (this.palco.precioParcialPagado >= this.palco.servicio + this.palco.precio + this.palco.servicioIva && this.listaAdiciones.length == 0) {
          this.cargando = false;
        }
        this.refrescar();
        this.cargando = false; // Asegurarse de establecerlo en false al final también
      });
    } else {
      this.cargando = false; // Si el usuario es nulo
    }
  }
  
  
  cambiarTotal() {

    this.valorAPagar = (this.porcentaje / 100) * (this.palco.precio + this.palco.servicio + this.palco.servicioIva);
    this.tax = (this.porcentaje / 100) * this.palco.servicioIva;
    if (this.valorAPagar + this.palco.precioParcialPagado <= (this.palco.precio + this.palco.servicio + this.palco.servicioIva)) {


    }
    else {
      //alert("Estas aportando más del valor total")
      this.openMensaje('Estas aportando más del valor total');
    }
  }


  cambiarTotalAdicion() {
    this.taxAdicion = this.seleccionAdicion * this.palco.servicioIvaAdicion
    this.valorPagarAdicion = this.seleccionAdicion * (this.palco.precioAdicion + this.palco.servicioAdicion + this.palco.servicioIvaAdicion);

  }


  refrescar() {
    this.palcoServicio.getClientesDeUnPalco(this.idPalco).subscribe(response => {
      this.clientes = response
      if (this.clientes[0].numeroDocumento == this.usuario.numeroDocumento) {
        this.borrar = true
      }
    })
  }

  buscarCliente() {
    this.dataServicio.getClientePorId(this.numeroDocumento).subscribe(response => {
      if (response != null) {
        this.clienteAgregado = response
      }
      else {
        //alert("No tenemos este numero de documento registrado")
        this.openMensaje('No tenemos este numero de documento registrado');
      }
    })
  }



  agregarCliente() {
    var clienteEncontrado = false;
    for (var i = 0; i < this.clientes.length; i = i + 1) {
      if (this.clienteAgregado.numeroDocumento == this.clientes[i].numeroDocumento) {
        clienteEncontrado = true;
      }
    }


    if (clienteEncontrado == false) {
      if (this.clienteAgregado.numeroDocumento == null) {
        //alert("Agrega un amigo para continuar")
        this.openMensaje('Agrega un amigo para continuar');
      }
      else {

        if (this.clientes.length < this.palco.personasMaximas) {
          this.palcoServicio.agregarClientesAlPalco(this.idPalco, this.clienteAgregado.numeroDocumento).subscribe(response => {

            response;

            this.refrescar()
            //alert("Cliente: "+ this.clienteAgregado.numeroDocumento+ " agregado al palco")
            this.openMensaje("Cliente: " + this.clienteAgregado.numeroDocumento + " agregado al palco");
          },
            error => { this.openMensaje(error.error.message); }

          )
        }
        else {
          //alert("Cantidad maxima de personas en el palcos alcanzada")
          this.openMensaje('Cantidad maxima de personas en el palcos alcanzada');
        }
      }
    }
    else {
      //alert("Este cliente ya esta en el palco")
      this.openMensaje('Este cliente ya esta en el palco');
    }
  }

 

  quitarCliente(idCliente) {

    if (this.clientes.length == 1) {
      //alert("No puedes eliminar al ultimo participante del palco")
      this.openMensaje('No puedes eliminar al ultimo participante del palco');
    }

    else {
      this.palcoServicio.quitarClientesAlPalco(this.palco.id, idCliente).subscribe((response) => {
        response
        //alert("Has Eliminado al cliente "+idCliente)
        //this.ngOnInit()
        this.openMensaje('Has Eliminado al cliente ' + idCliente, 'onInit');
      },
        (error) => {
          //alert(error)
          this.openMensaje(error);
        }
      )
    }

  }
  openMensaje(mensajeT: string, openD?: string): void {
    let screenWidth = screen.width;
    let anchoDialog: string = '500px';
    let anchomax: string = '80vw';
    let altoDialog: string = '250';
    if (screenWidth <= 600) {
      anchoDialog = '100%';
      anchomax = '100%';
      altoDialog = 'auto';
    }
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: anchoDialog,
      maxWidth: anchomax,
      height: altoDialog,
      data: {
        mensaje: mensajeT
      }
    });
    if (openD == 'onInit') {
      this.ngOnInit();
    }
  }
  payment() {


    if (this.cargando == false) {
      this.cargando = true

      this.ordenService.addOrden(3, this.usuario.numeroDocumento, "-1", this.palco.id, -1, '00000', 0,-1).subscribe(response => {
        this.codigoOrden = response;
        this.descripcion = "Aporte al palco " + this.palco.numeroDentroDeEvento;

        const inputElement = document.getElementById('codigoO') as HTMLInputElement;

      // Cambia el valor del input
      inputElement.value = this.codigoOrden; // Reemplaza "Nuevo valor" por el valor que desees asignar

        const form = document.getElementById('myForm') as HTMLFormElement;
        form.action = this.url;
        form.submit();
  
      }, () => {
        this.cargando = false; // Manejo de error
      });

    }
  }

  payment2() {


    if (this.cargando == false) {
      this.cargando = true


      this.ordenService.addOrden(4, this.usuario.numeroDocumento, "-1", this.palco.id, -1, '00000', this.seleccionAdicion,-1).subscribe(response => {
        this.codigoOrden = response;
        this.descripcion = "Aporte al palco " + this.palco.numeroDentroDeEvento;

        const inputElement = document.getElementById('codigoO2') as HTMLInputElement;

        // Cambia el valor del input
        inputElement.value = this.codigoOrden; // Reemplaza "Nuevo valor" por el valor que desees asignar
          const form = document.getElementById('myForm2') as HTMLFormElement;
          form.action = this.url;
          form.submit();
        
      }, () => {
        this.cargando = false; // Manejo de error
      });

     


    }
  }
} */

import { Md5 } from 'ts-md5/dist/md5';
import { API_URL2, IVA, respuesta, terminal } from './../../../app.constants';
import { PalcosDataService } from 'src/app/service/data/palcos-data.service';
import { ActivatedRoute } from '@angular/router';
import { HardcodedAutheticationService } from './../../../service/hardcoded-authetication.service';
import { UsuariosDataService } from './../../../service/data/usuarios-data.service';
import { Palco } from './../../../administradores/admin-perfil/admin-eventos/admin-palcos/palco.model';
import { Cliente } from './../../cliente.model';
import { Component, OnInit } from '@angular/core';
import { MensajeComponent } from 'src/app/mensaje/mensaje.component';
import { MatDialog } from '@angular/material/dialog';
import { OrdenDataService } from 'src/app/service/data/orden-data.service';


@Component({
  selector: 'app-agregar-amigos',
  templateUrl: './agregar-amigos.component.html',
  styleUrls: ['./agregar-amigos.component.css']
})
export class AgregarAmigosComponent implements OnInit {
  clienteNoEsNulo: boolean = false;
  user = '';
  usuario: Cliente
  palco: Palco
  idPalco
  clientes: Cliente[] = []
  clienteAgregado: Cliente
  numeroDocumento
  IVA
  merchantId
  accountId
  ApiKey
  referenceCode: string
  porcentaje
  borrar: boolean
  taxAdicion = 0
  tax = 0
  idEvento: string
  valorAPagar = 0
  valorPagarAdicion = 0
  seleccionAdicion
  listaAdiciones: number[]
  entrarPersonas: number
  terminal
  respuesta
  codigoOrden
  descripcion
  cargando
  url
  constructor(private route: ActivatedRoute,
    private ordenService: OrdenDataService,
    private autenticador: HardcodedAutheticationService, private dataServicio: UsuariosDataService, private palcoServicio: PalcosDataService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.url = 'https://merchant.paymentsway.co/cartaspago/redirect'
    this.cargando = true
    this.terminal = terminal
    this.respuesta = respuesta
    this.entrarPersonas = 0
    this.listaAdiciones = []
    this.IVA = IVA
    this.borrar = false


    this.clienteAgregado = {
      celular: null,
      contrasena: null,
      correo: null,
      nombre: null,
      numeroDocumento: null,
      publicidad: null,
      tipoDocumento: null,
      usuario: null,
      tipo: null
    }

    this.usuario = {
      nombre: "",
      numeroDocumento: null,
      tipoDocumento: "",
      usuario: "",
      contrasena: "",
      celular: null,
      correo: "",

      publicidad: null,

      tipo: null,
    }
    this.palco = {
      id: null,
      nombre: null,
      nombreEvento: null,
      personasAdentro: null,
      personasMaximas: null,
      precio: null,
      precioParcialPagado: null,
      reservado: null,
      servicio: null,
      vendido: null,
      numeroDentroDeEvento: null,
      fechaVendido: null,
      servicioIva: null,
      proceso: null,
      disponible: null,
      idLocalidad: null,
      reserva: null,
      precioAlterno: null,
      servicioAlterno: null,
      servicioIvaAlterno: null,
      adiciones: null,
      maximoAdiciones: null,
      precioAdicion: null,
      servicioAdicion: null,
      servicioIvaAdicion: null,
      metodo: null

    }

    this.user = this.autenticador.getUsuario();

    this.route.paramMap.subscribe(params => {
      this.idPalco = params.get('idPalco');
      this.dataServicio.getCliente(this.user).subscribe(response => {
        this.usuario = response;


        this.refrescarPalco()
      })
    })

  }



  refrescarPalco() {
    if (this.usuario != null) {
      this.palcoServicio.getPalcoAmigos(0, this.idPalco).subscribe(response => {

        this.palco = response.palco;
        this.idEvento = response.evento;

        let cantidad = this.palco.maximoAdiciones - this.palco.personasMaximas;
        for (let i = 1; i <= cantidad; i++) {
          this.listaAdiciones.push(i);
        }


        if (this.palco.precioParcialPagado >= this.palco.servicio + this.palco.precio + this.palco.servicioIva && this.listaAdiciones.length == 0) {
          this.cargando = false;
        }
        this.refrescar();
        this.cargando = false; // Asegurarse de establecerlo en false al final también
      });
    } else {
      this.cargando = false; // Si el usuario es nulo
    }
  }


  cambiarTotal() {

    this.valorAPagar = (this.porcentaje / 100) * (this.palco.precio + this.palco.servicio + this.palco.servicioIva);
    this.tax = (this.porcentaje / 100) * this.palco.servicioIva;
    if (this.valorAPagar + this.palco.precioParcialPagado <= (this.palco.precio + this.palco.servicio + this.palco.servicioIva)) {


    }
    else {
      //alert("Estas aportando más del valor total")
      this.openMensaje('Estas aportando más del valor total');
    }
  }


  cambiarTotalAdicion() {
    this.taxAdicion = this.seleccionAdicion * this.palco.servicioIvaAdicion
    this.valorPagarAdicion = this.seleccionAdicion * (this.palco.precioAdicion + this.palco.servicioAdicion + this.palco.servicioIvaAdicion);

  }


  refrescar() {
    this.palcoServicio.getClientesDeUnPalco(this.idPalco).subscribe(response => {
      this.clientes = response
      if (this.clientes[0].numeroDocumento == this.usuario.numeroDocumento) {
        this.borrar = true
      }
    })
  }

  buscarCliente() {
    this.dataServicio.getClientePorId(this.numeroDocumento).subscribe(response => {
      if (response != null) {
        this.clienteAgregado = response
      }
      else {
        //alert("No tenemos este numero de documento registrado")
        this.openMensaje('No tenemos este numero de documento registrado');
      }
    })
  }



  agregarCliente() {
    var clienteEncontrado = false;
    for (var i = 0; i < this.clientes.length; i = i + 1) {
      if (this.clienteAgregado.numeroDocumento == this.clientes[i].numeroDocumento) {
        clienteEncontrado = true;
      }
    }


    if (clienteEncontrado == false) {
      if (this.clienteAgregado.numeroDocumento == null) {
        //alert("Agrega un amigo para continuar")
        this.openMensaje('Agrega un amigo para continuar');
      }
      else {

        if (this.clientes.length < this.palco.personasMaximas) {
          this.palcoServicio.agregarClientesAlPalco(this.idPalco, this.clienteAgregado.numeroDocumento).subscribe(response => {

            response;

            this.refrescar()
            //alert("Cliente: "+ this.clienteAgregado.numeroDocumento+ " agregado al palco")
            this.openMensaje("Cliente: " + this.clienteAgregado.numeroDocumento + " agregado al palco");
          },
            error => { this.openMensaje(error.error.message); }

          )
        }
        else {
          //alert("Cantidad maxima de personas en el palcos alcanzada")
          this.openMensaje('Cantidad maxima de personas en el palcos alcanzada');
        }
      }
    }
    else {
      //alert("Este cliente ya esta en el palco")
      this.openMensaje('Este cliente ya esta en el palco');
    }
  }



  quitarCliente(idCliente) {

    if (this.clientes.length == 1) {
      //alert("No puedes eliminar al ultimo participante del palco")
      this.openMensaje('No puedes eliminar al ultimo participante del palco');
    }

    else {
      this.palcoServicio.quitarClientesAlPalco(this.palco.id, idCliente).subscribe((response) => {
        response
        //alert("Has Eliminado al cliente "+idCliente)
        //this.ngOnInit()
        this.openMensaje('Has Eliminado al cliente ' + idCliente, 'onInit');
      },
        (error) => {
          //alert(error)
          this.openMensaje(error);
        }
      )
    }

  }
  openMensaje(mensajeT: string, openD?: string): void {
    let screenWidth = screen.width;
    let anchoDialog: string = '500px';
    let anchomax: string = '80vw';
    let altoDialog: string = '250';
    if (screenWidth <= 600) {
      anchoDialog = '100%';
      anchomax = '100%';
      altoDialog = 'auto';
    }
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: anchoDialog,
      maxWidth: anchomax,
      height: altoDialog,
      data: {
        mensaje: mensajeT
      }
    });
    if (openD == 'onInit') {
      this.ngOnInit();
    }
  }
  payment() {


    if (this.cargando == false) {
      this.cargando = true

      this.ordenService.addOrden(3, this.usuario.numeroDocumento, "-1", this.palco.id, -1, '00000', 0, -1).subscribe(response => {
        this.codigoOrden = response;
        this.descripcion = "Aporte al palco " + this.palco.numeroDentroDeEvento;

        const inputElement = document.getElementById('codigoO') as HTMLInputElement;

        // Cambia el valor del input
        inputElement.value = this.codigoOrden; // Reemplaza "Nuevo valor" por el valor que desees asignar

        const form = document.getElementById('myForm') as HTMLFormElement;
        form.action = this.url;
        form.submit();

      }, () => {
        this.cargando = false; // Manejo de error
      });

    }
  }

  payment2() {


    if (this.cargando == false) {
      this.cargando = true


      this.ordenService.addOrden(4, this.usuario.numeroDocumento, "-1", this.palco.id, -1, '00000', this.seleccionAdicion, -1).subscribe(response => {
        this.codigoOrden = response;
        this.descripcion = "Aporte al palco " + this.palco.numeroDentroDeEvento;

        const inputElement = document.getElementById('codigoO2') as HTMLInputElement;

        // Cambia el valor del input
        inputElement.value = this.codigoOrden; // Reemplaza "Nuevo valor" por el valor que desees asignar
        const form = document.getElementById('myForm2') as HTMLFormElement;
        form.action = this.url;
        form.submit();

      }, () => {
        this.cargando = false; // Manejo de error
      });




    }
  }
}